import { AxiosResponse } from 'axios'

import { BackendResponse } from '@/app/types/api/config'
import {
  RecaptchaVerifyRequestBody,
  ServiceEndpoint,
} from '@/app/types/api/resources/service'

import client from '@/app/api/client'

export default {
  serverStatus(): BackendResponse<unknown> {
    return client.get(ServiceEndpoint.ServerStatus)
  },

  verifyRecaptchaToken(
    data: RecaptchaVerifyRequestBody,
  ): Promise<AxiosResponse<void>> {
    return client.post(ServiceEndpoint.RecaptchaVerify, data)
  },
}
